import React from 'react';
import { observer } from 'mobx-react';
import storeLoader from 'app/stores/storeLoader';
import AlertingTable from 'app/views/alerting/components/AlertingTable';
import AlertCollection from 'app/stores/alerting/AlertCollection';
import { Button, Card, Flex, Heading, LinkButton } from 'core/components';
import { withRouter } from 'react-router-dom';

@storeLoader('$alerting.policyCollection')
@withRouter
@observer
class AlertToolResult extends React.Component {
  state = {
    collection: new AlertCollection()
  };

  componentDidMount() {
    const { collection } = this.state;
    const { tool } = this.props;
    // Override because we don't need server filters and it breaks inline filters.
    collection.serverSortableFields = [];
    // Override because we don't want to clearFilters on result collapse/expand.
    collection.clearFilters = () => {};
    // flatten these because the collection re-nests under filter before fetching.
    const { filter, pagination } = tool.query_object;
    collection.setServerFilter({ ...filter, pagination });
  }

  handleNavigateToAlerts = () => {
    const { history, tool } = this.props;
    history.push('/v4/alerting', {
      ...tool.query_object
    });
  };

  render() {
    const { tool = {}, onCloseToolResult } = this.props;
    const { collection } = this.state;

    return (
      <Card
        p={0}
        className="tool-result-alerts"
        display="flex"
        flexDirection="column"
        gap={2}
        minHeight={750}
        height="100%"
        overflow="hidden"
      >
        <Flex alignItems="center" justifyContent="space-between" p={2} pb={0}>
          <Heading level={5} m={0} flex={1}>
            {tool.title}
          </Heading>
          <Flex alignItems="center" gap={1}>
            <LinkButton icon="shield" small minimal onClick={this.handleNavigateToAlerts}>
              View in Alerting
            </LinkButton>
            <Button text="Close" small icon="cross" onClick={() => onCloseToolResult(tool)} color="muted" minimal />
          </Flex>
        </Flex>

        <AlertingTable collection={collection} miniKebab useVirtualizedTable />
      </Card>
    );
  }
}

export default AlertToolResult;
